import baseURL from "../common/axios";
class Commonservices {
  GetMenus(Type) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "Menu/GetMenuSubMenuList?Type=" + Type + ""
    );
  }
  CheckMenuRights(EntityId) {
    debugger;
    return baseURL.httpMSUserManageMentUrl.get(
      "EntityOperationsDeptRoleMap/CheckMenuRights?EntityId=" + EntityId + ""
    );
  }
}
export default new Commonservices();
